import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const BRAND_API_URL = `${API_HOST}/api/brand`;
const STORE_API_URL = `${BRAND_API_URL}/store`;

function* searchBrands() {
  yield takeEvery(actions.SEARCH_BRANDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${BRAND_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_BRANDS_ENDED });
    }
  });
}

function* searchStores() {
  yield takeEvery(actions.SEARCH_STORES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${STORE_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_STORES_ENDED });
    }
  });
}

function* findBrand() {
  yield takeEvery(actions.FIND_BRAND, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${BRAND_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_BRAND_ENDED });
    }
  });
}

function* findStore() {
  yield takeEvery(actions.FIND_STORE, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${STORE_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_STORE_ENDED });
    }
  });
}

function* createBrand() {
  yield takeEvery(actions.CREATE_BRAND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], BRAND_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_BRAND_ENDED });
    }
  });
}

function* createStore() {
  yield takeEvery(actions.CREATE_STORE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], STORE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_STORE_ENDED });
    }
  });
}

function* updateBrand() {
  yield takeEvery(actions.UPDATE_BRAND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], BRAND_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_BRAND_ENDED });
    }
  });
}

function* updateStore() {
  yield takeEvery(actions.UPDATE_STORE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], STORE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_STORE_ENDED });
    }
  });
}

function* batchUpdateStoreDisplayOrder() {
  yield takeEvery(actions.BATCH_UPDATE_STORE_DISPLAY_ORDER, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${STORE_API_URL}/displayOrder`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.BATCH_UPDATE_STORE_DISPLAY_ORDER_END });
    }
  });
}

function* deleteBrands() {
  yield takeEvery(actions.DELETE_BRANDS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], BRAND_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_BRANDS_ENDED });
    }
  });
}

function* deleteStores() {
  yield takeEvery(actions.DELETE_STORES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], STORE_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_STORES_ENDED });
    }
  });
}

function* createBrandBatch() {
  yield takeEvery(actions.CREATE_BRAND_BATCH, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${BRAND_API_URL}/batch`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_BRAND_BATCH_ENDED });
    }
  });
}

function* createStoreBatch() {
  yield takeEvery(actions.CREATE_STORE_BATCH, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${STORE_API_URL}/batch`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_STORE_BATCH_ENDED });
    }
  });
}

function* createStoreAccount() {
  yield takeEvery(actions.CREATE_STORE_ACCOUNT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${BRAND_API_URL}/storeAccount`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_STORE_ACCOUNT_END });
    }
  });
}

function* updateStoreAccount() {
  yield takeEvery(actions.UPDATE_STORE_ACCOUNT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${BRAND_API_URL}/storeAccount`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_STORE_ACCOUNT_ENDD });
    }
  });
}

function* quicklyCreateStoreAccount() {
  yield takeEvery(actions.QUICKLY_CREATE_STORE_ACCOUNT, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${BRAND_API_URL}/storeAccount/quick`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.QUICKLY_CREATE_STORE_ACCOUNT_END });
    }
  });
}

function* searchStoreAccounts() {
  yield takeEvery(actions.SEARCH_STORE_ACCOUNTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${BRAND_API_URL}/storeAccount/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_STORE_ACCOUNTS_END });
    }
  });
}

function* searchStoreAccountRoles() {
  yield takeEvery(actions.SEARCH_STORE_ACCOUNT_ROLES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${BRAND_API_URL}/storeAccount/rolePermissions/role/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_STORE_ACCOUNT_ROLES_ENDED });
    }
  });
}

function* createStoreAccountRole() {
  yield takeEvery(actions.CREATE_STORE_ACCOUNT_ROLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${BRAND_API_URL}/storeAccount/rolePermissions/role`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_STORE_ACCOUNT_ROLE_ENDED });
    }
  });
}

function* findStoreAccountRole() {
  yield takeEvery(actions.FIND_STORE_ACCOUNT_ROLE, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${BRAND_API_URL}/storeAccount/rolePermissions/role/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_STORE_ACCOUNT_ROLE_ENDED });
    }
  });
}

function* updateStoreAccountRole() {
  yield takeEvery(actions.UPDATE_STORE_ACCOUNT_ROLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${BRAND_API_URL}/storeAccount/rolePermissions/role`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_STORE_ACCOUNT_ROLE_ENDED });
    }
  });
}

function* getStoreAccountPermissions() {
  yield takeEvery(actions.GET_STORE_ACCOUNT_PERMISSIONS, function* (action) {
    try {
      const { onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${BRAND_API_URL}/storeAccount/rolePermissions/permission`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_STORE_ACCOUNT_PERMISSIONS_ENDED });
    }
  });
}

function* resetStoreAccountPassword() {
  yield takeEvery(actions.RESET_STORE_ACCOUNT_PASSWORD, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${BRAND_API_URL}/storeAccount/resetPassword`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.RESET_STORE_ACCOUNT_PASSWORD_END });
    }
  });
}

function* updateStoreAccountStatus() {
  yield takeEvery(actions.UPDATE_STORE_ACCOUNT_STATUS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${BRAND_API_URL}/storeAccount/status`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_STORE_ACCOUNT_STATUS_END });
    }
  });
}

function* searchStoreCategories() {
  yield takeEvery(actions.SEARCH_STORE_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${STORE_API_URL}/category?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_STORE_CATEGORIES_END });
    }
  });
}

function* updateStoreCategories() {
  yield takeEvery(actions.UPDATE_STORE_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${STORE_API_URL}/category`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_STORE_CATEGORIES_END });
    }
  });
}

function* searchBrandCategories() {
  yield takeEvery(actions.SEARCH_BRAND_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${BRAND_API_URL}/brandCategory?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_BRAND_CATEGORIES_END });
    }
  });
}

function* createBrandCategory() {
  yield takeEvery(actions.CREATE_BRAND_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${BRAND_API_URL}/brandCategory`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_BRAND_CATEGORY_END });
    }
  });
}

function* updateBrandCategory() {
  yield takeEvery(actions.UPDATE_BRAND_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${BRAND_API_URL}/brandCategory`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_BRAND_CATEGORY_ENDED });
    }
  });
}

function* deleteBrandCategories() {
  yield takeEvery(actions.DELETE_BRAND_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${BRAND_API_URL}/brandCategory`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_BRAND_CATEGORIES_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createBrand),
    fork(createStore),
    fork(searchBrands),
    fork(searchStores),
    fork(findBrand),
    fork(findStore),
    fork(updateBrand),
    fork(updateStore),
    fork(batchUpdateStoreDisplayOrder),
    fork(deleteBrands),
    fork(deleteStores),
    fork(createBrandBatch),
    fork(createStoreBatch),
    fork(searchStoreAccounts),
    fork(createStoreAccount),
    fork(updateStoreAccount),
    fork(resetStoreAccountPassword),
    fork(updateStoreAccountStatus),
    fork(quicklyCreateStoreAccount),
    fork(searchStoreCategories),
    fork(updateStoreCategories),
    fork(searchBrandCategories),
    fork(createBrandCategory),
    fork(updateBrandCategory),
    fork(deleteBrandCategories),
    fork(searchStoreAccountRoles),
    fork(createStoreAccountRole),
    fork(updateStoreAccountRole),
    fork(findStoreAccountRole),
    fork(getStoreAccountPermissions),
  ]);
}
